import { StoresInstance } from "Globals/Stores";
import { SpokenLanguageType } from "Shared";

export const isSpokenLanguageOfType = (spokenLanguageId: string | undefined | null, spokenLanguageType: SpokenLanguageType) => {
    if (!spokenLanguageId) return false;
    const { spokenLanguages } = StoresInstance.Domain.LookupStore;
    const spokenLanguage = spokenLanguages.find((s) => s.id === spokenLanguageId);
    return spokenLanguage?.type === spokenLanguageType;
};
